<template>
  <div class="modalwarnInfo">
    <p class="warn_one">
      禁运物品说明内容：为了切实提升运输安全管理，保障人民生命财产安全，联帮帮平台不支持运输下列货物：
    </p>
    <p class="warn_two">
      1.各类武器、弹药。如枪支、子弹、炮弹、手榴弹、地雷、炸弹等。
    </p>
    <p class="warn_two">2.各类易爆炸性物品。如雷管、炸药、火药、鞭炮等。</p>
    <p class="warn_two">
      3.各类易燃烧性物品。包括液体、气体和固体。如汽油、煤油、桐油、酒精、生漆、柴油、气雾剂、气体打火机、瓦斯气瓶、磷、硫磺、火柴等。
    </p>
    <p class="warn_two">
      4.各类易腐蚀性物品。如火硫酸、盐酸、硝酸、有机溶剂、农药、双氧水、危险化学品等。
    </p>
    <p class="warn_two">5.各类放射性元素及容器。如铀、钴、镭、钚等。</p>
    <p class="warn_two">6.各类烈性毒药。如铊、氰化物、砒霜等。</p>
    <p class="warn_two">
      7..各类麻醉药物。如鸦片(包括罂粟壳、花、苞、叶)、吗啡、可卡因、海洛因、大麻、冰毒、麻黄素及其它制品等。
    </p>
    <p class="warn_two">
      8.各类生化制品和传染性物品。如炭疽、危险性病菌、医药用废弃物等。
    </p>
    <p class="warn_two">
      9.各种危害国家安全和社会政治稳定以及淫秽出版物、宣传片、印刷品
    </p>
    <p class="warn_two">
      10.各种妨害公共卫生的物品。如尸骨、动物器官、肢体、未经硝制的的兽皮、未经药制的兽骨等
    </p>
    <p class="warn_two">
      11.国家法律、法规、行政规章命令禁止流通、进出境物品。如国家秘密文件和资料、国家货币及伪造货币和有价证券、仿真武器、濒危野生动物及其仿制品等。
    </p>
    <p class="warn_two">
      12、其他国家法律法规禁止运输的，在运输、装卸和贮存保管过程中容易造成人身伤亡和财产损毁而需要特别防护的货物。
    </p>

    <p class="warn_three">
      *对于以上国家法律法规禁止限制运输的物品，联帮帮平台作为承运主体无法进行运输，托运人不应在联帮帮平台提交相关订单。因托运人故意隐瞒运输货物的性质而造成损失，托运人需要承担一切经济和法律后果。
    </p>
    <div class="got_it">
      <div class="got_it_button" @click="gotIt()">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "prohibitedArticles",
  data() {
    return {};
  },
  created() {},
  methods: {
    gotIt() {
      this.$emit("gotIt");
    }
  }
};
</script>
<style lang="scss">
.modalwarnInfo {
  padding: 32px 28px;
  box-sizing: border-box;
  .warn_one {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 18px;
    color: #ef4141;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 0;
    margin-bottom: 10px;
  }
  .warn_two {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 34px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin: 0;
  }
  .warn_three {
    margin: 0;
    margin-top: 8px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #ef4141;
    line-height: 34px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
  .got_it {
    margin-top: 34px;
    width: 100%;
    display: flex;
    justify-content: center;
    .got_it_button {
      cursor: pointer;
      width: 137px;
      height: 32px;
      background: #1785ff;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      justify-content: center;
      align-items: center;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #ffffff;
      line-height: 20px;
      font-style: normal;
      text-transform: none;
    }
  }
}
</style>
